



































































import {Stored} from 'vue-stored-prop-decorator';
import {Component, Vue} from '@/shared/component';
import {Emit, Watch} from 'vue-property-decorator';
import {ResultType} from '@/shared/xhttp';
import {Client} from '@/models';

import CrudClientFilter from '@/components/Crud/Client/Filter.vue';
import CrudClientEditDialog from '@/components/Crud/Client/EditDialog.vue';
import CrudClientList from '@/components/Crud/Client/List.vue';
import CrudDeleteDialog from '@/components/Crud/DeleteDialog.vue';

import storeClient, {ClientFilter} from '@/stores/modules/client';

@Component({
	components: {
		CrudClientFilter,
		CrudClientEditDialog,
		CrudClientList,
		CrudDeleteDialog,
	}
})
export default class ClientListView extends Vue {

	@Stored(() => storeClient) private clients!: ResultType<Client>;
	@Stored(() => storeClient) private filters!: ClientFilter;

	private imgPath: string = "";

	private editClient: Client = null;
	private deletedClient: Client = null;
	private storeClient = storeClient;

	public created(): void {
		this.routeWatcher();
	}

	@Watch('$route')
	private routeWatcher() {
	}

	@Emit()
	private onCreate(): void {
		this.editClient = new Client();
		this.refresh();
	}

	private refresh(): void {
		storeClient.dispatch('getC', { filters: true });
	}
}
